.summary {
    padding: var(--mantine-spacing-xs) var(--mantine-spacing-sm);
    border: 1px solid var(--mantine-color-default-border);
    border-radius: var(--mantine-radius-md);
    background-color: var(--mantine-color-ldGray-0);
}
